export default "__VITE_ASSET__BFaEgzf$__"